import {
  REQUEST_PASSWORD_RESET,
  REQUEST_PASSWORD_RESET_SUCCESS,
  REQUEST_PASSWORD_RESET_ERROR,
  VERIFY_MFA_CODE,
  VERIFY_MFA_CODE_SUCCESS,
  VERIFY_MFA_CODE_ERROR,
  RESET_PASSWORD,
  RESET_PASSWORD_SUCCESS,
  RESET_PASSWORD_ERROR,
} from "./actionTypes";

const initialState = {
  forgetSuccessMsg: null,
  forgetError: null,
  requestResetLoading: false,
  requestResetSuccess: null,
  requestResetError: null,
  verifyMFALoading: false,
  verifyMFASuccess: null,
  verifyMFAError: null,
  resetPasswordLoading: false,
  resetPasswordSuccess: null,
  resetPasswordError: null,
};

const forgetPassword = (state = initialState, action) => {
  switch (action.type) {
    // Step 1: Request Password Reset
    case REQUEST_PASSWORD_RESET:
      return {
        ...state,
        requestResetLoading: true,
        requestResetSuccess: null,
        requestResetError: null,
      };
    case REQUEST_PASSWORD_RESET_SUCCESS:
      return {
        ...state,
        requestResetLoading: false,
        requestResetSuccess: action.payload,
      };
    case REQUEST_PASSWORD_RESET_ERROR:
      return {
        ...state,
        requestResetLoading: false,
        requestResetError: action.payload,
      };

    // Step 2: Verify MFA Code
    case VERIFY_MFA_CODE:
      return {
        ...state,
        verifyMFALoading: true,
        verifyMFASuccess: null,
        verifyMFAError: null,
      };
    case VERIFY_MFA_CODE_SUCCESS:
      return {
        ...state,
        verifyMFALoading: false,
        verifyMFASuccess: action.payload,
      };
    case VERIFY_MFA_CODE_ERROR:
      return {
        ...state,
        verifyMFALoading: false,
        verifyMFAError: action.payload,
      };

    // Step 3: Reset Password
    case RESET_PASSWORD:
      return {
        ...state,
        resetPasswordLoading: true,
        resetPasswordSuccess: null,
        resetPasswordError: null,
      };
    case RESET_PASSWORD_SUCCESS:
      return {
        ...state,
        resetPasswordLoading: false,
        resetPasswordSuccess: action.payload,
      };
    case RESET_PASSWORD_ERROR:
      return {
        ...state,
        resetPasswordLoading: false,
        resetPasswordError: action.payload,
      };

    default:
      return state;
  }
};

export default forgetPassword;
